import { render, staticRenderFns } from "./segment-grid-groups.vue?vue&type=template&id=80451f8e&"
import script from "./segment-grid-groups.vue?vue&type=script&lang=js&"
export * from "./segment-grid-groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports